module.exports = __webpack_public_path__ + "static/media/ewmp.990bf8ce.png";